import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button, Form, Modal, Nav } from "react-bootstrap";
import { FaRegSquarePlus } from "react-icons/fa6";
import toast from "react-hot-toast";
import { BiSolidEditAlt } from "react-icons/bi";
import CustomisedModal from "../../components/Modal/CustomisedModal";
import { MdDelete } from "react-icons/md";
import { IoMdArrowBack } from "react-icons/io";
import filtericon from "../../assets/images/Filter.png";
import { Box, Paper, Switch, Tooltip } from "@mui/material";
import DataTable from "react-data-table-component";
import deleteIcon from "../../assets/images/delete.png";
import editIcon from "../../assets/images/edit.png";
import { getCompleteOfferPromocodes, updateOfferPromoCodeStatus } from "../../api/context/promocodes";
import Loader from "../../components/loader/loader";
import { checkUserPermissions } from "../../helpers/permission";
import defaultlogo from '../../assets/svg/logo-dashboard-v1.png';
import { FiImage } from "react-icons/fi";

const queueDatatableCustomStyles = {
  headCells: {
    style: {
      display: "flex",
      justifyContent: "center",
      fontWeight: '600',
      fontSize: '14px',
    },
  },
  cells: {
    style: {
      display: "flex",
      justifyContent: "center",
      fontSize: '12px',
      fontWeight: '500',
      padding: '12px',
    },
  },
};

const PromoCodesPage = () => {
  const navigate = useNavigate();
  const [show, setShow] = useState(false);
  const [showimg, setShowImg] = useState(false);
  const [promoimg, setPromoImg] = useState([]);
  const [totalRows, setTotalRows] = useState(0);
  const [limit, setLimit] = useState(10);
  const [page, setPage] = useState(1);
  const [update, setUpdate] = useState(false);
  const [search, setSearch] = useState("");
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [initial, setInitial] = useState(false);
  const [activeTab, setActiveTab] = useState('active');

  // Navigation functions
  const handleCreatePromoCode = () => {
    navigate('/create-promocodes');
  };

  const handleEditPromoCode = (promocode) => {
    navigate(`/edit-promocodes/${promocode.id}`);
  };

  const handleShowImage = (promoimage) => {
    setShowImg(true);
    setPromoImg(promoimage)
  }

  const [modal, setModal] = useState(false);
  const toggleModal = () => {
    setModal(!modal);
  };

  const user = JSON.parse(localStorage.getItem('user'));

  const handleCloseImage = () => {
    setShowImg(false);
  }

  // Toggle functions for different status fields
  const handleToggleStatus = (id) => {
    const previousData = [...data];
    const currentItem = data.find(item => item.id === id);
    const newStatus = !currentItem?.isActive;

    setData(prevData =>
      prevData.map(item =>
        item.id === id
          ? { ...item, isActive: newStatus }
          : item
      )
    );

    updateOfferPromoCodeStatus(id, { field: 'isActive', value: newStatus })((response) => {
      if (response?.data?.statusCode === 200) {
        toast.success("Status updated successfully!");
        // Refresh data to ensure consistency
        setUpdate(!update);
      } else {
        setData(previousData);
        toast.error(response?.data?.message || "Failed to update status");
      }
    });
  };

  const handleToggleOfferPageVisibility = (id) => {
    const previousData = [...data];
    const currentItem = data.find(item => item.id === id);
    const newVisibility = !currentItem?.showOnOfferPage;

    setData(prevData =>
      prevData.map(item =>
        item.id === id
          ? { ...item, showOnOfferPage: newVisibility }
          : item
      )
    );

    updateOfferPromoCodeStatus(id, { field: 'showOnOfferPage', value: newVisibility })((response) => {
      if (response?.data?.statusCode === 200) {
        toast.success("Offer page visibility updated successfully!");
        setUpdate(!update);
      } else {
        setData(previousData);
        toast.error(response?.data?.message || "Failed to update offer page visibility");
      }
    });
  };

  const handleToggleCheckoutPageVisibility = (id) => {
    const previousData = [...data];
    const currentItem = data.find(item => item.id === id);
    const newVisibility = !currentItem?.showOnCheckoutPage;

    setData(prevData =>
      prevData.map(item =>
        item.id === id
          ? { ...item, showOnCheckoutPage: newVisibility }
          : item
      )
    );

    updateOfferPromoCodeStatus(id, { field: 'showOnCheckoutPage', value: newVisibility })((response) => {
      if (response?.data?.statusCode === 200) {
        toast.success("Checkout page visibility updated successfully!");
        setUpdate(!update);
      } else {
        setData(previousData);
        toast.error(response?.data?.message || "Failed to update checkout page visibility");
      }
    });
  };

  const columns = [
    {
      name: "S.No.",
      selector: (row, index) => ((page * limit) - limit) + (index + 1),
      width: '80px',
      center: true,
      style: {
        textAlign: 'center',
      },
    },
    {
      id: "image",
      name: "Image",
      selector: (row) => row?.image,
      cell: (row) => (
        <div className="promocode_img_wrapper" onClick={() => handleShowImage(row?.image ? row?.image : defaultlogo)}>
          <div className="image-container">
            <img
              src={row?.image || defaultlogo}
              alt={row?.name}
              className="img-fluid"
              onError={(e) => {
                e.target.style.display = 'none';
                e.target.nextSibling.style.display = 'block';
              }}
            />
            <div className="broken-image-fallback" style={{ display: 'none' }}>
              <FiImage className="text-muted" size={24} />
            </div>
          </div>
        </div>
      ),
      width: "90px",
    },
    {
      id: "code",
      name: "Code",
      selector: (row) => row?.code,
      cell: (row) => (
        <Tooltip title={row?.code} disableInteractive placement="top">
          <div className="text-truncate">{row?.code}</div>
        </Tooltip>
      ),
      width: "130px",
    },
    {
      id: "name",
      name: "Name",
      selector: (row) => row?.name,
      cell: (row) => (
        <Tooltip title={row?.name} disableInteractive placement="top">
          <div className="text-truncate">{row?.name}</div>
        </Tooltip>
      ),
      width: "130px",
    },
    {
      name: "Status",
      selector: (row) => row.status,
      cell: (row, index) => (
        <div className="status_wrap_datatable">
          <div className="d-flex justify-content-center">
            <Switch
              size=""
              id={`custom-switch-${index}`}
              checked={row.isActive === true}
              onChange={() => handleToggleStatus(row.id)}
              className="custom-switch"
            />
          </div>
        </div>
      ),
      sortable: true,
      center: true,
      width: "130px",
    },
    {
      id: "MinCart",
      name: "MinCart",
      selector: (row) => row?.minimumCartAmount,
      cell: (row) => (
        <Tooltip title={row?.minimumCartAmount} disableInteractive placement="top">
          <div className="text-truncate">{row?.minimumCartAmount}</div>
        </Tooltip>
      ),
      width: "130px",
    },
    {
      id: "Discount",
      name: "Discount (%)",
      selector: (row) => row?.discountPercentage,
      cell: (row) => (
        <Tooltip title={row?.discountPercentage} disableInteractive placement="top">
          <div className="text-truncate">{row?.discountPercentage}</div>
        </Tooltip>
      ),
      width: "130px",
    },

    {
      name: "Offer Page",
      selector: (row) => row.showOnOfferPage,
      cell: (row, index) => (
        <div className="status_wrap_datatable">
          <div className="d-flex justify-content-center">
            <Switch
              size=""
              id={`offer-page-switch-${index}`}
              checked={row.showOnOfferPage === true}
              onChange={() => handleToggleOfferPageVisibility(row.id)}
              className="custom-switch"
            />
          </div>
        </div>
      ),
      sortable: true,
      center: true,
      width: "160px",
    },
    {
      name: "Checkout Page",
      selector: (row) => row.showOnCheckoutPage,
      cell: (row, index) => (
        <div className="status_wrap_datatable">
          <div className="d-flex justify-content-center">
            <Switch
              size=""
              id={`checkout-page-switch-${index}`}
              checked={row.showOnCheckoutPage === true}
              onChange={() => handleToggleCheckoutPageVisibility(row.id)}
              className="custom-switch"
            />
          </div>
        </div>
      ),
      sortable: true,
      center: true,
      width: "160px",
    },
    {
      id: "Expiration",
      name: "Expiration",
      selector: (row) => row?.expiryDate,
      cell: (row) => {
        const dateString = row?.expiryDate || '';
        const datePart = dateString.split('T')[0] || dateString;

        let formattedDate = datePart;
        if (datePart.match(/^\d{4}-\d{2}-\d{2}$/)) {
          const [year, month, day] = datePart.split('-');
          formattedDate = `${day}/${month}/${year}`;
        }

        return (
          <Tooltip title={row?.expiryDate} disableInteractive placement="top">
            <div className="text-truncate">{formattedDate}</div>
          </Tooltip>
        );
      },
      width: "130px",
    },
  ];

  const fetchPromoCodesData = async () => {
    setLoading(true);

    const params = {
      page: page,
      limit: limit,
      search
    };

    // Use activeTab for filtering
    if (activeTab === "active") {
      params.status = "active";
    } else if (activeTab === "inactive") {
      params.status = "inactive";
    } else if (activeTab === "expired") {
      params.status = "expired";
    } else {
      params.status = "all";
    }

    try {
      getCompleteOfferPromocodes(params)((response) => {
        if (response?.statusCode === 200) {
          setData(response.data.offers);
          setTotalRows(response?.data?.pagination?.totalItems || 0);
        } else {
          setData([]);
          setTotalRows(0);
        }
        setLoading(false);
      });
    } catch (error) {
      console.error("Error fetching promocodes:", error);
      setData([]);
      setTotalRows(0);
      setLoading(false);
    }
  };

  const handleEditClick = (id) => {
    navigate(`/edit-promocodes/${id}`);
  };

  const handlePerRowsChange = (newPerPage, currentPage) => {
    setLimit(newPerPage);
    setPage(1); // Reset to first page when changing rows per page
  };

  const handlePageChange = (currentPage) => {
    setPage(currentPage);
  };

  const handleFilterChange = (filter) => {
    setActiveTab(filter);
    setPage(1); // Reset to first page when changing tabs
  };

  useEffect(() => {
    fetchPromoCodesData();
  }, [page, limit, activeTab]);

  useEffect(() => {
    let timeout = setTimeout(() => {
      if (initial) {
        setPage(1); // Reset to first page when searching
        setUpdate(!update);
      } else {
        setInitial(true);
      }
    }, 500);

    return () => {
      clearTimeout(timeout);
    };
  }, [search]);

  return (
    <>
      <div>
        <div className="d-flex justify-content-between align-items-center mb-3">
          <div className="d-flex align-items-center">
            <h3 className="mb-0 fw-bolder">Promocodes</h3>
          </div>

          <div className="action-buttons-row d-flex align-items-center">
            {checkUserPermissions("manage_promocodes") ? (
              <Button className="request_btn" onClick={handleCreatePromoCode}>
                <FaRegSquarePlus className="icon" />
                Add new promocode
              </Button>
            ) : (
              <></>
            )}
          </div>
        </div>

        <div className="row">
          <div className="col-12">
            <div className="shadow-none mb-2">
              <div className="filter_wrapper">
                <Nav
                  variant="tabs"
                  defaultActiveKey="active"
                  activeKey={activeTab}
                  onSelect={setActiveTab}
                  className="custom-order-tabs"
                >
                  {/* <Nav.Item>
                    <Nav.Link
                      eventKey="all"
                      className={`fs-7 fw-semibold ${activeTab === 'all' ? 'fw-bold text-dark active-tab' : 'text-secondary'}`}
                      style={{
                        padding: '12px 24px',
                        backgroundColor: activeTab === 'all' ? '#f8f9fa' : 'transparent',
                        transition: 'all 0.3s ease',
                        color: activeTab === 'all' ? '#000' : '#6c757d'
                      }}
                      onClick={() => handleFilterChange("all")}
                    >
                      All
                    </Nav.Link>
                  </Nav.Item> */}
                  <Nav.Item>
                    <Nav.Link
                      eventKey="active"
                      className={`fs-7 fw-semibold ${activeTab === 'active' ? 'fw-bold text-dark active-tab' : 'text-secondary'}`}
                      style={{
                        padding: '12px 24px',
                        backgroundColor: activeTab === 'active' ? '#f8f9fa' : 'transparent',
                        transition: 'all 0.3s ease',
                        color: activeTab === 'active' ? '#000' : '#6c757d'
                      }}
                      onClick={() => handleFilterChange("active")}
                    >
                      Active
                    </Nav.Link>
                  </Nav.Item>
                  <Nav.Item>
                    <Nav.Link
                      eventKey="inactive"
                      className={`fs-7 fw-semibold ${activeTab === 'inactive' ? 'fw-bold text-dark active-tab' : 'text-secondary'}`}
                      style={{
                        padding: '12px 24px',
                        backgroundColor: activeTab === 'inactive' ? '#f8f9fa' : 'transparent',
                        transition: 'all 0.3s ease',
                        color: activeTab === 'inactive' ? '#000' : '#6c757d'
                      }}
                      onClick={() => handleFilterChange("inactive")}
                    >
                      Inactive
                    </Nav.Link>
                  </Nav.Item>
                     <Nav.Item>
                    <Nav.Link
                      eventKey="expired"
                      className={`fs-7 fw-semibold ${activeTab === 'expired' ? 'fw-bold text-dark active-tab' : 'text-secondary'}`}
                      style={{
                        padding: '12px 24px',
                        backgroundColor: activeTab === 'expired' ? '#f8f9fa' : 'transparent',
                        transition: 'all 0.3s ease',
                        color: activeTab === 'expired' ? '#000' : '#6c757d'
                      }}
                      onClick={() => handleFilterChange("expired")}
                    >
                      Expired
                    </Nav.Link>
                  </Nav.Item>
                </Nav>
              </div>
            </div>
          </div>

          <CustomisedModal
            isOpen={modal}
            customClass={"policy_modal"}
            toggle={toggleModal}
          >
            <h5>Are you sure you want to remove this item?</h5>
            <div className="policy_Agree">
              <Button
                onClick={() => {
                  setModal(!modal);
                }}
                size="lg"
                className="btn_cancel"
              >
                Cancel
              </Button>
              <Button
                size="lg"
                className="btn"
                onClick={null}
              >
                Delete
              </Button>
            </div>
          </CustomisedModal>

          <Box className="products-and-options" sx={{ mt: 1 }}>
            <Paper square className='shadow-none border border-blue-grey-200'>
              <div>
                <DataTable
                  columns={columns}
                  onRowClicked={(row) => handleEditClick(row?.id)}
                  data={data}
                  progressPending={loading}
                  progressComponent={
                    <div style={{ height: "60vh" }}>
                      <Loader />
                    </div>
                  }
                  pagination
                  paginationServer
                  paginationTotalRows={totalRows}
                  paginationPerPage={limit}
                  paginationRowsPerPageOptions={[10, 50, 100, 150]}
                  pointerOnHover
                  highlightOnHover
                  onChangeRowsPerPage={handlePerRowsChange}
                  onChangePage={handlePageChange}
                  paginationDefaultPage={page}
                  customStyles={queueDatatableCustomStyles}
                />
              </div>
            </Paper>
          </Box>
        </div>

        {/* Image Modal Display */}
        <Modal
          show={showimg}
          onHide={handleCloseImage}
          centered
          className='modal_create'
        >
          <Modal.Header closeButton>
          </Modal.Header>
          <div className="promo_modal_img">
            <img src={promoimg} alt='' className="img-fluid" />
          </div>
        </Modal>
      </div>
    </>
  );
};

export default PromoCodesPage;